import { unsyncedReason } from './timestamps';

export async function findUnsyncedRecords(database) {
  const results = [];

  await Promise.all(
    Object.values(database.collections).map(async collection => {
      const docs = await collection.find().exec();

      docs.forEach(doc => {
        const document = doc.toJSON(true);
        const reason = unsyncedReason(document);

        if (reason === null) {
          return;
        }

        results.push({
          collection: collection.name,
          id: document.id,
          updatedAt: document.updatedAt,
          lastSyncedAt: document.lastSyncedAt,
          reason,
          document
        });
      });
    })
  );

  return results.sort((left, right) =>
    `${left.collection}:${left.id}`.localeCompare(
      `${right.collection}:${right.id}`
    )
  );
}

export function subscribeUnsyncedRecords(database, onChange) {
  const rescan = () => {
    findUnsyncedRecords(database).then(onChange);
  };

  rescan();

  const subscriptions = Object.values(database.collections).map(collection =>
    collection.$.subscribe(rescan)
  );

  return () => {
    subscriptions.forEach(subscription => subscription.unsubscribe());
  };
}
